import { useMemo } from 'react';

import { type ExamCourse } from '../../constants/types';
import { getCertificateTemplates } from '../../utils/certificate-templates';

export default function useGetDuringAndPostExamSettingsFormOptions(
  type: ExamCourse['type'] | undefined | null,
  language: ExamCourse['language'] | undefined | null,
) {
  const passCertificateTemplates = useMemo(() => {
    if (!type || !language) {
      return [];
    }
    return getCertificateTemplates(type, language, 'pass');
  }, [type, language]);

  const failCertificateTemplates = useMemo(() => {
    if (!type || !language) {
      return [];
    }
    return getCertificateTemplates(type, language, 'fail');
  }, [type, language]);

  return {
    passCertificateTemplates,
    failCertificateTemplates,
  };
}
